import React from 'react';
import { Batch } from '../../lib/thetape-data';
import { ArrowLeftIcon } from 'lucide-react';
interface BatchHeaderProps {
  batch: Batch;
  onBack: () => void;
}
export function BatchHeader({
  batch,
  onBack
}: BatchHeaderProps) {
  const formatCurrency = (val: number) => new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0
  }).format(val);
  return <div className="bg-slate-900 border-b border-slate-800 p-6 mb-6" data-id="element-288">
      <button onClick={onBack} className="flex items-center gap-2 text-slate-400 hover:text-white mb-4 text-sm transition-colors" data-id="element-289">
        <ArrowLeftIcon size={16} data-id="element-290" />
        <span data-id="element-291">Back to All Batches</span>
      </button>

      <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-6" data-id="element-292">
        <div data-id="element-293">
          <h1 className="text-2xl font-mono font-semibold text-white mb-2" data-id="element-294">
            {batch.id}
          </h1>
          <div className="flex items-center gap-4 text-sm text-slate-400 font-mono" data-id="element-295">
            <span data-id="element-296">Closed: {batch.closeDate}</span>
            <span className="w-1 h-1 bg-slate-600 rounded-full" data-id="element-297"></span>
            <span data-id="element-298">{batch.invoiceCount} Invoices</span>
          </div>
        </div>

        <div className="flex gap-8" data-id="element-299">
          <div className="text-right" data-id="element-300">
            <span className="block text-xs text-slate-500 font-mono uppercase mb-1" data-id="element-301">
              Total Funded
            </span>
            <span className="text-2xl font-mono text-white font-medium" data-id="element-302">
              {formatCurrency(batch.totalAmount)}
            </span>
          </div>
          <div className="text-right" data-id="element-303">
            <span className="block text-xs text-slate-500 font-mono uppercase mb-1" data-id="element-304">
              Verification
            </span>
            <span className="text-2xl font-mono text-emerald-500 font-medium" data-id="element-305">
              100%
            </span>
          </div>
        </div>
      </div>
    </div>;
}